import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ArticleType} from './article-type.model';
import {ArticleTypeService} from "./article-type.service";
import {first, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class ArticleTypeFacade {
  constructor(private articleTypeService: ArticleTypeService) {
  }

  getAllArticleTypes(clientId: number): Observable<ArticleType[]> {
    return this.articleTypeService.getAllArticleTypes(clientId);
  }

  getEmblemsTypesByClientId(clientId: number): Observable<ArticleType[]> {
    return this.articleTypeService.getAllArticleTypes(clientId).pipe(
      first(),
      map(types => types.filter(x => x.type === 'emblem'))
    );
  }

  getTextTypesByClientId(clientId: number): Observable<ArticleType[]> {
    return this.articleTypeService.getAllArticleTypes(clientId)
      .pipe(
        first(),
        map(types => types.filter(x => x.type === 'text'))
      );
  }

  getGraphicTypesByClientId(clientId: number): Observable<ArticleType[]> {
    return this.articleTypeService.getAllArticleTypes(clientId)
      .pipe(
        first(),
        map(types => types.filter(x => x.type === 'graphic'))
      );
  }

  getEmblemAndGraphicTypesByClientId(clientId: number): Observable<ArticleType[]> {
    return this.articleTypeService.getAllArticleTypes(clientId)
      .pipe(
        first(),
        map(types => types.filter(x => x.type === 'graphic' || x.type === 'emblem'))
      );
  }

  getOrderedArticleTypesForArticle(articleId: string | undefined): Observable<ArticleType[]> {
    return this.articleTypeService.getCurrentArticleTypes(articleId);
  }
}
